import { createSelector } from "reselect";
import * as moment from "moment";

export const getCouponsAsList = createSelector(
  (state) => state.homeReducers.offers,
  (entities) => Object.values(entities).filter((item) => item.tipo === "cupon")
);

export const getPromotionsAsList = createSelector(
  (state) => state.homeReducers.offers,
  (entities) =>
    Object.values(entities).filter(
      (item) =>
        item.tipo === "oferta" &&
        moment(item.fecha_culminacion).isAfter(moment())
    )
);

export const getReferralDiscount = createSelector(
  (state) => state.homeReducers.referralDiscount,
  (referralDiscount) => referralDiscount?.discount
);
